<script setup>
import {useAuthenticationStore} from '@/stores'
import NewRequestButton from '@/components/ui/requests/NewRequestButton.vue'
import TheBreadCrumbs from '@shared-components/TheBreadCrumbs.vue'
import MetaTitle from '@shared-components/ui/MetaTitle.vue'
import {computed} from 'vue'
import {useRoute} from 'vue-router'
import {redirectToExternalUrl} from '@shared-utils/url/redirectToExternalUrl'
import {AppUrls} from '@shared-utils/auth/appUrls'

const route = useRoute()

const {logout, isImpersonated} = useAuthenticationStore()

const BreadcrumbsRoutesToSkip = ['ad-account-requests.accounts.list']

// Computed
const showBreadCrumb = computed(
  () =>
    route.meta?.type === 'form' ||
    [
      'ad-alerts.list',
      'landings.list',
      'employees.list',
      'quick-books-customers.list',
      'request.agency-general',
      'conversions.list',
      'ab-tests.profile',
    ].includes(route.name),
)
const showLayoutTitle = computed(() => !showBreadCrumb.value)

// Methods
const handleLogout = async () => {
  await logout()

  redirectToExternalUrl(AppUrls.login(), {
    redirect_url: window.location.href,
  })
}
</script>

<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <the-bread-crumbs v-if="showBreadCrumb" class="ml-3" :routes-to-skip="BreadcrumbsRoutesToSkip" />

      <template v-if="showLayoutTitle">
        <h5 class="custom fs-5 fw-semibold m-0">
          <meta-title />
        </h5>
      </template>
    </div>

    <div class="d-flex align-items-center custom gap-3">
      <new-request-button />

      <div class="dropdown">
        <button
          id="dropdownUserButton"
          aria-expanded="false"
          class="btn btn-secondary user-btn"
          data-bs-toggle="dropdown"
          type="button"
        >
          <i class="fa-light fa-user"></i>
        </button>
        <ul aria-labelledby="dropdownUserButton" class="dropdown-menu">
          <li>
            <router-link :to="{name: 'user'}" class="dropdown-item">My Profile</router-link>
          </li>
          <li v-if="!isImpersonated">
            <hr class="dropdown-divider" />
          </li>
          <li v-if="!isImpersonated">
            <button @click="handleLogout" class="dropdown-item">Log out</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.user-btn {
  color: #6b7280 !important;
  padding: 5px 9px !important;
}
</style>
